import { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Form } from 'react-simple-form-control';
import documentoService from '../../services/DocumentoService';

const EnvioContratoProcuracao = ({ form, setForm, loading, setLoading, listFileUpload, setListFileUpload }) => {
    const [lstSelectTiposDocumentos, setLstSelectTiposDocumentos] = useState([]);
    const [selectTiposDocumentos, setSelectTiposDocumentos] = useState(null);
    const [lstSelectResponsaveis, setLstSelectResponsaveis] = useState([]);
    const [selectResponsaveis, setSelectResponsaveis] = useState(null);

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("Selecione um arquivo");
    const fileInputRef = useRef(null);

    useEffect(() => {
        load();
    }, []);

    async function load() {
        setListFileUpload(listFileUpload);

        setLoading(true);

        //TRATAR O FORMATO VINDO DO FORMUÁRIO
        setLstSelectResponsaveis(form.listResponsaveis.value.map(e => { return { value: e.codigo, label: e.descricao } }));
        setSelectTiposDocumentos({ label: "SELECIONE", value: null });
        setLstSelectTiposDocumentos(form.listTiposDocumentos.value.map(e => { return { value: e.codigo, label: e.descricao } }));
        setSelectResponsaveis({ label: "SELECIONE", value: null });

        setLoading(false);
    }

    function checkArquivo() {
        if (!selectedFile) return false;
        return listFileUpload.some(item =>
            item.arquivo.name === selectedFile.name &&
            item.arquivo.type === selectedFile.type &&
            item.arquivo.size === selectedFile.size
        );
    }

    async function onClickExcluir(event) {
        const idParaExcluir = parseInt(event.currentTarget.accessKey, 10);
        let filteredList = listFileUpload.filter(item => item.id !== idParaExcluir);
        setListFileUpload(filteredList);
    }

    function handleFileChange(e) {
        const file = e.target.files[0];
        if (file) {
            const validos = /\.(jpg|png|gif|pdf|doc|docx)$/i;
            if (!validos.test(file.name)) {
                toast.warn(`Tipo de arquivo não permitido: ${file.name}`);
                setSelectedFile(null);
                setFileName("Selecione um arquivo");
                return;
            }
            setSelectedFile(file);
            setFileName(file.name.length > 55 ? file.name.substring(0, 55) + "..." : file.name);
        } else {
            setSelectedFile(null);
            setFileName("Selecione um arquivo");
        }
    }

    function handleClick() {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    async function handleAddFile() {
        let _form = { ...form };

        if (!selectedFile) {
            toast.warn("Selecione um arquivo.");
            return;
        }
        if ((_form.tipoDocumento.value === 0 || _form.tipoDocumento.value === "0") && _form.tipoArquivo.value == 2) {
            toast.warn('Selecione o tipo de Documento.');
        }
        else if (selectedFile == undefined || selectedFile == undefined) { toast.warn('Selecione o Arquivo.'); }
        else {
            if (listFileUpload !== undefined && listFileUpload.length > 0 && listFileUpload.filter(checkArquivo).length > 0)
                toast.warn("Não é permitido adicionar o mesmo arquivo mais de uma vez.");
            else {
                const tipoDoc = _form.tipoArquivo.value === '1' ? '---' : (lstSelectTiposDocumentos.find(opt => opt.value === _form.tipoDocumento.value)?.label || '---');
                var idTipoDoc = _form.tipoArquivo.value == 1 ? undefined : _form.tipoDocumento.value;

                const novoItem = {
                    name: selectedFile.name,
                    extensao: selectedFile.type.split('/').pop(),
                    tipo: tipoDoc,
                    idTipo: idTipoDoc,
                    arquivo: selectedFile,
                    id: listFileUpload.length + 1,
                    idTipoArquivo: _form.tipoArquivo.value,
                    tipoArquivo: _form.tipoArquivo.value == 1 ? 'Contrato' : 'Outros Documentos',
                    representante: _form.representanteEscolha.value.trim(),
                    representanteCpf: _form.representanteEscolhaCpf.value.trim()
                };

                setListFileUpload([...listFileUpload, novoItem]);

                setSelectedFile(null);
                setFileName("Selecione um arquivo");
                if (fileInputRef.current) fileInputRef.current.value = "";

                if (_form.tipoConvenio.value == 2) {
                    var countArquivo = 0;

                    if (listFileUpload.length > 0) {
                        listFileUpload.forEach(element => {
                            if (element.idTipo === idTipoDoc && element.representante.toUpperCase() === _form.representanteEscolha.value.toUpperCase()) {
                                // tipo contrato social/estatuto somente para pessoa juríca
                                if (element.idTipo == 4 && element.representante !== _form.razaoSocial.value) {
                                    listFileUpload.pop();
                                    toast.error(`Tipo contrato social/estatuto somente para Pessoa Jurídica.`)
                                }
                                // tipo CPF ou RG somente para pessoa física
                                if ((element.idTipo == 5 || element.idTipo == 6) && element.representante === _form.razaoSocial.value) {
                                    listFileUpload.pop();
                                    toast.error(`Tipo CPF ou RG somente para Pessoa Física.`)
                                }
                                countArquivo++;
                            }
                            if (countArquivo > 1) {
                                listFileUpload.pop();
                                toast.error(`Arquivo já adicionado para o responsável selecionado.`)
                            }
                        });
                    }
                }
                setForm(_form);
                handleDrop();
            }
        }
    }

    async function onChangeResponsavel(event) {
        let responsavel = event.target.value;
        let listDocFiltered = await documentoService.OnGetTipos(form.tipoConvenio.value);

        onChangeTipoDocumento('cleanSelect');

        let newListTiposDocumentos;
        if (responsavel === '0') {
            newListTiposDocumentos = listDocFiltered;
        } else if (responsavel === 'razaoSocial') {
            newListTiposDocumentos = listDocFiltered.filter(doc => doc.codigo === '4');
        } else {
            newListTiposDocumentos = listDocFiltered.filter(doc => doc.codigo !== '4');
        }

        let representanteEscolha = '';
        let representanteEscolhaCpf = '';

        if (responsavel !== '0') {
            representanteEscolha = form[responsavel]?.value || '';
            switch (responsavel) {
                case 'razaoSocial':
                    representanteEscolhaCpf = form.cnpj?.value || '';
                    break;
                case 'nomeAdmin':
                    representanteEscolhaCpf = form.cpfAdmin?.value || '';
                    break;
                case 'nomeRepresentante':
                    representanteEscolhaCpf = form.cpfRepresentante?.value || '';
                    break;
                case 'nomeRepresentante2':
                    representanteEscolhaCpf = form.cpfRepresentante2?.value || '';
                    break;
                case 'nomeRepresentante3':
                    representanteEscolhaCpf = form.cpfRepresentante3?.value || '';
                    break;
                case 'nomeRepresentante4':
                    representanteEscolhaCpf = form.cpfRepresentante4?.value || '';
                    break;
                case 'nomeRepresentante5':
                    representanteEscolhaCpf = form.cpfRepresentante5?.value || '';
                    break;
                default:
                    representanteEscolhaCpf = '';
            }
        }

        setForm(prevForm => ({
            ...prevForm,
            listTiposDocumentos: { ...prevForm.listTiposDocumentos, value: newListTiposDocumentos },
            representanteEscolha: { ...prevForm.representanteEscolha, value: representanteEscolha },
            representanteEscolhaCpf: { ...prevForm.representanteEscolhaCpf, value: representanteEscolhaCpf }
        }));
    }

    async function onChangeTipoDocumento(value) {
        let _form = { ...form };
        setSelectTiposDocumentos(value);
        _form.tipoDocumento.value = value ? parseInt(value.value, 10) : 0;
        setForm(_form);
    }

    function handleDrop() {
        setSelectedFile(null);
        setFileName("Selecione um arquivo");
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    function _handleArquivoChange(event) {
        let _form = { ...form };
        if (event.target.checked && event.target.value !== undefined) {
            _form.tipoArquivo.value = parseInt(event.target.value);
            _form.tipoDocumento.value = 0;
            setSelectTiposDocumentos({ label: "SELECIONE", value: null });
            setListFileUpload([]);
            setSelectedFile(null);
            setFileName("Selecione um arquivo");
        }
        setForm(_form);
    }

    const todoItems = listFileUpload.map((todo) =>
        <tr className="" >
            <td className="" title={todo.name}>{todo.name.length > 15 ? todo.name.substring(0, 14) + '...' : todo.name}</td>
            <td className="">{todo.extensao}</td>
            <td className="">{todo.tipo}</td>
            <td hidden={form.tipoConvenio.value == '2'} className="">{todo.tipoArquivo}</td>
            <td hidden={form.tipoConvenio.value == '1'} className="">{todo.representante}</td>
            <td className=""><i className="fa fa-times-circle" aria-hidden="true" onClick={onClickExcluir} accessKey={todo.id}></i></td>
        </tr>
    );

    return (
        <Form formControl={form} onChangeForm={_form => setForm(_form)}>
            <div className="card-body">
                <ul className="uninterconvenioempresas uninter-passo-interno">
                    <li>
                        <label hidden={form.tipoEmpresa.value > 0}>Selecione o tipo da empresa</label>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" hidden={(form.tipoEmpresa.value == 0 || form.tipoEmpresa.value == 2) || (form.tipoEmpresa.value == 1 && (form.tipoConvenio.value == 0 || form.tipoConvenio.value == 2))}>
                            <h4 className="titleFormulario">Envio de Contrato e/ou Procuração</h4>
                            <div className="uninter-declaro-convenioempresas uninter-desconto-contrato-top" style={{ maxWidth: '900px' }}>
                                <span id="enviocontrato">Envio Opcional</span>
                            </div>
                            <div className="uninter-declaro-convenioempresas uninter-desconto-contrato" style={{ maxWidth: '900px' }}>
                                Caso tenha que inserir dados/cláusulas de um contrato próprio e/ou Procuração do Representante Legal, favor enviar arquivo abaixo.
                                <br /><br />
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 marginBox">
                                    <div className="row botton-px-20">
                                        <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                style={{ display: "none" }}
                                                onChange={handleFileChange}
                                                accept="application/pdf,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            />
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text label-file" id="basic-addon2">{"Contrato / Procuração"}</span>
                                                </div>
                                                <label type="text" className="form-control label-file input-white-file" aria-label="Large" id="inputGroupFile012" aria-describedby="basic-addon2 basic-addon3">{fileName}</label>
                                                <div className="input-group-append">
                                                    <span className="input-group-text label-file search-file" id="basic-addon3" onClick={(e) => handleClick(e.target.files)}>{"Buscar"}</span>
                                                </div>
                                                <div className="input-group-append">
                                                    <span className="input-group-text label-file search-file btn-adicionar" id="basic-addon4" onClick={(e) => handleAddFile(e.target.files)}>{"Adicionar"}</span>
                                                </div>
                                                <div className="input-group-append">
                                                    <span className="input-group-text label-file drop-file" id="basic-addon5" onClick={(e) => handleDrop()}><i className="fa fa-times" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
                                        </div>
                                    </div>
                                    <span className="error" id="listaError" ></span>
                                    <div>
                                        {todoItems.length > 0 &&
                                            <table className="uninter-table-documentos">
                                                <tr>
                                                    <th className="primeira">Nome </th>
                                                    <th className="other">Extensão </th>
                                                    <th className="other">Tipo Arquivo </th>
                                                    {form.tipoConvenio.value != '2' ? <th className="other">Tipo Documento</th> : ''}
                                                    {form.tipoConvenio.value == '2' ? <th className="other">Responsável</th> : ''}
                                                    <th className="ultima">Excluir</th>
                                                </tr>
                                                {todoItems}
                                            </table>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" hidden={(form.tipoEmpresa.value == 0 || form.tipoEmpresa.value == 1) && (form.tipoConvenio.value == 0 || form.tipoConvenio.value == 1)}>
                            <h4 className="titleFormulario">Envio de arquivos</h4>
                            <div className="uninter-declaro-convenioempresas uninter-documentos-top">
                                <span id="enviocontrato">{form.tipoConvenio.value == 1 ? "Envio Opcional" : "Envio Obrigatório"}</span>
                            </div>
                            <div className="uninter-declaro-convenioempresas uninter-documentos">
                                Para inserir contrato e outros documentos, favor selecionar o arquivo abaixo e adicionar.<br /><br />
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 marginBox">
                                    <div className="row">
                                        <ul className="uninter-declaro-convenioempresas uninter-desconto-pagamento">
                                            <li className="form-check">
                                                <input type="radio" id="contrato" name="tipoArquivo" value="1" onChange={_handleArquivoChange} disabled={form.tipoConvenio.value == '2'} />
                                                <label className="form-check-label ">Contrato</label>
                                                <input type="radio" id="documento" name="tipoArquivo" value="2" onChange={_handleArquivoChange} className="checkPagamento" />
                                                <label className="form-check-label checkPagamento">Outros Documentos</label><br />
                                            </li>
                                            <span className="error" id="tipoArquivoError"></span>
                                        </ul>
                                    </div>
                                    {!loading &&
                                        <div className="row" hidden={form.tipoArquivo.value == 0 || form.tipoArquivo.value == 1}>
                                            {lstSelectResponsaveis.length > 0 &&
                                                <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 uninter-campos" hidden={form.tipoConvenio.value == 1}>
                                                    <label>Selecione o responsável pelo envio dos documentos obrigatórios</label>
                                                    <Select
                                                        options={lstSelectResponsaveis}
                                                        value={selectResponsaveis}
                                                        isMulti={false}
                                                        onChange={onChangeResponsavel}
                                                    />
                                                    <span className="error" id="representanteEscolhaError"></span>
                                                </div>
                                            }
                                            <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 uninter-campos">
                                                <label>Selecione tipo de documento</label>
                                                <Select
                                                    options={lstSelectTiposDocumentos}
                                                    value={selectTiposDocumentos}
                                                    isMulti={false}
                                                    onChange={onChangeTipoDocumento}
                                                />
                                                <span className="error" id="tipoDocumentoError"></span>
                                            </div>
                                        </div>
                                    }
                                    {!(form.tipoArquivo.value == 0) &&
                                        <>
                                            <br />
                                            <div className="row botton-px-20">
                                                <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
                                                    <input
                                                        type="file"
                                                        ref={fileInputRef}
                                                        style={{ display: "none" }}
                                                        onChange={handleFileChange}
                                                        accept="application/pdf,image/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                    />
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text label-file" id="basic-addon2">{"Arquivo"}</span>
                                                        </div>
                                                        <label type="text" className="form-control label-file input-white-file" aria-label="Large" id="inputGroupFile012" aria-describedby="basic-addon2 basic-addon3">{fileName}</label>
                                                        <div className="input-group-append">
                                                            <span className="input-group-text label-file search-file" id="basic-addon3" onClick={(e) => handleClick(e.target.files)}>{"Buscar"}</span>
                                                        </div>
                                                        <div className="input-group-append">
                                                            <span className="input-group-text label-file search-file btn-adicionar" id="basic-addon4" onClick={(e) => handleAddFile(e.target.files)}>{"Adicionar"}</span>
                                                        </div>
                                                        <div className="input-group-append">
                                                            <span className="input-group-text label-file drop-file" id="basic-addon5" onClick={(e) => handleDrop()}><i className="fa fa-times" aria-hidden="true"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1">
                                                </div>
                                            </div>
                                            <span className="error" id="listaError" ></span>
                                            <div>
                                                {todoItems.length > 0 &&
                                                    <table className="uninter-table-documentos">
                                                        <tr>
                                                            <th className="primeira">Nome </th>
                                                            <th className="other">Extensão </th>
                                                            <th className="other">Tipo Arquivo </th>
                                                            {form.tipoConvenio.value != '2' ? <th className="other">Tipo Documento</th> : ''}
                                                            {form.tipoConvenio.value == '2' ? <th className="other">Responsável</th> : ''}
                                                            <th className="ultima">Excluir</th>
                                                        </tr>
                                                        {todoItems}
                                                    </table>
                                                }
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </Form >
    );
}

export default EnvioContratoProcuracao;